import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

interface WhatNew {
  title: string;
  titleKh: string;
  desc: string;
  descKh: string;
  date: string;
  img: string;
  class: string;
  url: string;
}


@Component({
  selector: 'app-what-new',
  standalone: true,
  imports: [NgFor, RouterLink, NgClass, NgIf, TranslateModule, RouterLinkActive],
  templateUrl: './what-new.component.html',
  styleUrl: './what-new.component.css'
})
export class WhatNewComponent {

    baseApiUrl = environment.baseApiUrl;
  
    activePaginateIcon = this.baseApiUrl + '/uploads/images/icons/active_paginate.svg';
    inactivePaginateIcon = this.baseApiUrl + '/uploads/images/icons/inactive_paginate.svg';
    activeNext = this.baseApiUrl + '/uploads/images/icons/next_active.png';
    inactiveNext = this.baseApiUrl + '/uploads/images/icons/next_inactive.png';
    inactivePrevious = this.baseApiUrl + '/uploads/images/icons/previous_inactive.png';
    activePrevious = this.baseApiUrl + '/uploads/images/icons/previous_active.png';
    
    page: number = 1;
    currentPage: number = 1;
  
    currentLanguage: string = '';
    
    constructor(private router: Router, private route: ActivatedRoute, private translate: TranslateService) {}   
    
    
    ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
        const pageParam = params.get('page');
    
        if (pageParam !== null) {
          this.page = +pageParam; // Convert to number if not null
        } else {
          this.page = 1; // Assign default value if param is null
        }
    
        this.currentPage = this.page;
      });
  
      this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    }
  
    whatNew1: WhatNew[] = [
      {
        title: 'NongHyup Bank, in partnership with NongHyup Finance (Cambodia), generously donates to AFESIP Cambodia',
        titleKh: 'ធនាគារណុងហឹប រួមនឹង​គ្រឹះស្ថាន​មីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន (ខេមបូឌា) ​ម.ក ផ្តល់ជំនួយឧបត្តម​ដល់​អង្គការ អាហ្វេស៊ីប កម្ពុជា ​(AFESIP Cambodia)',
        desc: 'NongHyup Bank, headquartered in the Republic of Korea, and NongHyup Finance (Cambodia) Plc, in the presence of NongHyup Bank President & CEO Lee Seok Yong along with the management of both institutions, made a generous donation on August 8, 2023...',
        descKh: 'ធនាគារ ណុងហឹប ដែលមានមូលដ្ឋាននៅសាធារណរដ្ឋ​កូរ៉េ រួមជាមួយ​គ្រឹះស្ថាន​មីក្រូ​ហិរញ្ញវត្ថុ ណុង​ហឹប ហ្វាយនែន (​ខេមបូឌា​) ម.ក ក្រោមវត្តមានលោក Lee Seok Yong ជាប្រធាននាយកប្រតិបត្តិ ធនាគារ ណុងហឹប និង គណៈគ្រប់គ្រងនៃស្ថាប័នទាំង២ កាលពី​ថ្ងៃ​អង្គារ ទី​៨ ខែសីហា ឆ្នាំ​២០២៣ បាន​នាំយក​ជំនួយ​ឧបត្ថម្ភជាសម្ភារ និង ថវិកា រួមមាន កញ្ចប់​ថវិកា ៥.០០០​ដុល្លារ និងអង្ករ ១តោន មី ៥០កេស ត្រីខ ៥០​ដុំ ស្ករស ៥០គីឡូ អំបិល ៥០​គីឡូ ប្រេងឆា ៣០ដប ទឹក​ស៊ីអ៊ីវ​ ៥០​យួរ ទឹកត្រី ៥០​យួរ ​ប្រគល់ជូន​ដល់​អង្គការ​អាហ្វេស៊ីប​កម្ពុជា ​(AFESIP Cambodia) និងផ្តល់ជូនដល់កុមារចំនួន ១៥៥នាក់ ដែលស្ថិតក្រោមការគ្រប់គ្រងរបស់អង្គការដោយក្នុងម្នាក់ៗ ទទួលបានសៀវភៅ ៥ក្បាល ប៊ិច ៥ដើម ខ្មៅដៃ ៥ដើម ជ័រលុប ១បន្ទាត់ ១ឈុត កាតាប១ និងដបទឹកចំនួន១​ស្ថិត​នៅ​​ក្នុងខណ្ឌដង្កោ រាជធានីភ្នំពេញ​ក្នុងគម្រប់ខួប​៥ឆ្នាំ នៃការចាប់ផ្តើមអាជីវកម្មនៅកម្ពុជា របស់​គ្រឹះស្ថាន​មីក្រូ​ហិរញ្ញវត្ថុ ណុង​ហឹប ហ្វាយនែន (​ខេមបូឌា​) ម.ក។',
        date: 'Tuesday August 15, 2023',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_2.jpg',
        class: 'nonghyup-bank',
        url: 'nonghyup-bank'
      },
      // {
      //   title: 'New Experience, Faster Credit Access with Less Papers',
      //   titleKh: 'បទពិសោធន៍ថ្មី កម្ចីកាន់តែរហ័ស កាត់បន្ថយក្រដាស ជាមួយ NH Finance Mobile',
      //   desc: 'NongHyup Finance introduces a platform-based lending so-called NH Finance Mobile. The client can apply for loan, check balance, and get instant promotion/update of the products and services.',
      //   descKh: 'ណុងហឹប ហ្វាយនែន បានដាក់ដំណើរការកម្មវិធី អិនអេច្ឆ ហ្វាយនែន ម៉ូបាល (NH Finance Mobile) ដើម្បីផ្តល់ភាពងាយស្រួល ប្រកបដោយភាពបត់បែនជូនអតិថិជន។ អតិថិជនអាចស្នើកម្ចី ពិនិត្យសមតុល្យ កាលបរិច្ឆេទបង់ប្រាក់ និងទទួលបានព័ត៌មានផ្សេងៗ ស្តីពីផលិតផល និងសេវាកម្ម ដែលផ្តល់ជូន តាមរយៈកម្មវិធី NH Finance Mobile។ ធ្វើការទាញយក NH Finance Mobile ឥឡូវនេះ!',
      //   date: 'Thursday June 29, 2023',
      //   img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_3.jpg',
      //   class: 'new-experience',
      //   url: 'new-experience'
      // },
      {
        title: 'Materials Contribution to Local Authorities at Kampong Thom Province',
        titleKh: 'ការបរិច្ចាគសម្ភារជូនដល់អាជ្ញាធរនៅក្នុងខេត្តកំពង់ធំ',
        desc: 'NongHyup Bank, headquartered in the Republic of Korea, and NongHyup Finance (Cambodia) Plc, in the presence of NongHyup Bank President & CEO Lee Seok Yong along with the management of both institutions, made a generous donation on August 8, 2023.',
        descKh: 'នៅថ្ងៃទី៣០ ខែឧសភា ឆ្នាំ២០២២ គ្រឹះស្ថានមីកូ្រហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន (ខេមបូឌា) ម.ក បាននាំយកសម្ភារមួយចំនួន ជូនសាលាឃុំចំនួន ៥ ដែលស្ថិតក្នុងសុ្រកសន្ទុក និងសុ្រកបារាយណ៍ ខេត្តកំពង់ធំ ដើម្បីសម្រួលដល់ការងាររបស់សាលាឃុំ ក្នុងការផ្តល់សេវាសាធារណៈជូនប្រជាពលរដ្ឋទូទៅក្នុងសហគមន៍។ សម្ភារទាំងអស់មានដូចជា កៅអីជ័រចំនួន ៧៥កៅអី ធុងដាក់សំរាមចំនួន ១០ធុង ក្រដាសA4 ចំនួន ១០កេស រួម ទាំងថវិការមួយចំនួនផងដែរ។',
        date: 'Friday June 10, 2022',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_4.jpg',
        class: 'material',
        url: 'material-contribution'
      },
      {
        title: 'NH Bank, NongHyup Finance Donated to AFESIP Cambodia',
        titleKh: 'ធនាគារ និងគ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន ផ្តល់ជំនួយដល់អង្គការ អាហ្វេស៊ីប កម្ពុជា',
        desc: 'NongHyup Bank and NongHyup Finance (Cambodia) Plc last Thursday on 21 April, 2022 jointly donated food, school items and money to AFESIP Cambodia, an NGO focusing on the welfare of victimised women and girls across the Kingdom. The donations – part',
        descKh: 'ធនាគារ ណុងហឹប នៃ​សាធារណរដ្ឋ​កូរ៉េ រួមជាមួយ​គ្រឹះស្ថាន​មីក្រូ​ហរិញ្ញវត្ថុ ណុង​ហឹប ហ្វាយនែន (​ខេមបូឌា​) ម.ក កាលពី​​ថ្ងៃទី​ ២១ ខែមេសា ឆ្នាំ​២០២២ បាន​នាំយក​ជំនួយ​ឧបត្ថម្ភ​ប្រគល់ជូន​ដល់​អង្គការ​អាហ្វេស៊ីប​កម្ពុជា ​(AFESIP Cambodia) ដែល​ស្ថិតនៅ​ក្នុងភូមិ​ ២៤ សង្កាត់​ព្រៃស ខណ្ឌដង្កោ រាជធានី ភ្នំពេញ​។ បច្ចុប្បន្ន អង្គការ​នេះ បាន​កំពុងធ្វើការ​ជួយ​ដល់​យុវនារី និង​កុមារ​រងគ្រោះ ឬ​មាន​ហានិភ័យ​ខ្ពស់​ដែល​ងាយ​រងគ្រោះ ដោយ​អំពើ​ជួញដូរ​ផ្លូវភេទ ហិង្សា រំលោភបំពាន រំលោភ​សេពសន្ថវៈ ដោយបាន​សហការ​ជាមួយ​គ្រួសារ​របស់​ពួកគាត់ ក្នុង​ការផ្តល់​សុវត្ថិភាព និង​ការផ្តល់​យុទ្ធសាស្ត្រ​ឱ្យ​ចាកចេញ​ប្រកបដោយ​និរន្តរភាព​។',
        date: 'Friday June 10, 2022',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_5.jpg',
        class: 'nh-bank',
        url: 'nh-donate'
      },
      {
        title: 'Chairs Contribution to Local Authorities at Kandal Province',
        titleKh: 'ការបរិច្ចាគកៅអីជូនដល់អាជ្ញាធរនៅក្នុងខេត្តកណ្តាល',
        desc: 'As a part of social activities as well as to be a good model and share good practices to the public and build strong relationship with the stakeholder, NongHyup Finance contributed 40 chairs to the local authorities in the',
        descKh: 'ជាផ្នែកមួយនៃសកម្មភាពសង្គម ក៏ដូចជាគំរូល្អក្នុងការចែករំលែកដល់សាធារណៈជន និងកសាងទំនាក់ទំនងរឹងមាំជាមួយអាជ្ញាធរ និងភាគីពាក់ព័ន្ធ នៅថ្ងៃទី១៦ ខែមេសា ឆ្នាំ២០២០ ណុងហឹប ហ្វាយនែន បានចូលរួមវិភាគទានកៅអីចំនួន ៤០កៅអី ដល់អាជ្ញាធរមូលដ្ឋានក្នុងតំបន់ប្រតិបត្តិការ របស់សាខាខេត្តកណ្តាល ។',
        date: 'Friday July 31, 2020',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_6.jpg',
        class: 'chairs',
        url: 'chair-contribution'
      }
    ];
  
    whatNew2: WhatNew[] = [
      {
        title: 'Stuff and Food Supply Contribution to Client at S’ang District Branch',
        titleKh: 'ការបរិច្ចាគសម្ភារ និងគ្រឿងបរិភោគដល់អតិថិជននៅសាខាស្រុកស្អាង',
        desc: 'To contribute and show the care of NH to the clients who met this hard situation, on 04 June 2020, NH also donates some stuff and food supply such as Rice:100 Kg, Canned Fish: 5 cases, Fish Sauce: 2 case, Instant Noodle: 2 cases, Sugar: 5 Kg, Salt: 5 Kg, Soybean...',
        descKh: 'ដើម្បីចូលរួមចំណែក និងបង្ហាញពីការយកចិត្តទុកដាក់របស់ ណុងហឹប ដល់អតិថិជនដែលជួបនឹងស្ថានភាពលំបាក នៅថ្ងៃទី០៤ ខែមិថុនា ឆ្នាំ២០២០ ណុងហឹប ក៏បានបរិច្ចាគសម្ភារ និងគ្រឿងបរិភោគមួយចំនួនដូចជាអង្ករ ១០០គីឡូ ត្រីខកំប៉ុង ៥កេស ទឹកត្រី ២កេស មី ២កេស ស្ករស ៥គីឡូ អំបិល ៥គីឡូ ប្រេងសណ្តែក ២ដប ទឹកស៊ីអ៊ីវ ៣ដប និងថវិការសម្រាប់សប្បុរសធម៌ចំនួន ១០០ដុល្លារ ថែមទៀតផង។',
        date: 'Monday June 22, 2020',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_7.jpg',
        class: 'stuff-and-food',
        url: 'stuff-food'
      },
      {
        title: 'School Donation to 287 students at Prey Veng Province',
        titleKh: 'កម្មវិធីបរិច្ចាគសម្ភារសិក្សាដល់សិស្សានុសិស្សចំនួន ២៨៧នាក់',
        desc: 'As a part of social activities as well as support the education system at local communities, we also donated school stationeries and some school materials to 287 students at Prey Thom Primary School in Pr...',
        descKh: 'ជាផ្នែកមួយនៃសកម្មភាពសង្គម ក៏ដូចជាការចូលរួមគាំទ្រលើវិស័យអប់រំនៅតាមសហគមន៍មូលដ្ឋាន យើងបានធ្វើការបរិច្ចាគនូវ សម្ភារសិក្សាមួយចំនួនដល់សិស្សានុសិស្សចំនួន ២៨៧នាក់ នៅសាលាបឋមសិក្សាព្រៃធំដែលស្ថិតក្នុងភូមិព្រៃធំ ឃុំគោខ្ចក ស្រុកកំពង់ត្របែក ខេត្តព្រៃងវែង។',
        date: 'Monday June 22, 2020',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_8.jpg',
        class: 'school-donation',
        url: 'school-donate'
      },
      {
        title: 'Contribution of Materials on Water Festival in Kampot Province',
        titleKh: 'ការបរិច្ចាគសម្ភារបរិក្ខារសម្រាប់ពិធីបុណ្យអុំទូកនៅខេត្តកំពត',
        desc: 'Water Festival is celebrated throughout the country in November each year; and one of the festival’s major activities is boat racing which is organized in Phnom Penh and in some provinces with rivers. In November 2019,...',
        descKh: 'ពីធីបុណ្យអុំទូក ត្រូវបានប្រារព្ធធ្វើឡើងទូរទាំងប្រទេស នៅខែវិច្ឆិកា ជារៀងរាល់ឆ្នាំ ហើយសកម្មភាពដែលសំខាន់បំផុតរបស់ពិធីបុណ្យនេះគឺ ការប្រណាំងទូក ដែលរៀបចំក្នុងរាជធានីភ្នំពេញ និងតាមបណ្តាខេត្តមួយចំនួនដែលមានទន្លេ។ នៅខែវិច្ឆិកា​ ឆ្នាំ២០១៩ ណុងហឹប បានបរិច្ចាគមួកចំនួន ​៣០០មួក និងអាវយឺតចំនួន ៣០០អាវ ដល់អាជ្ញាធរក្នុងស្រុកកំពង់ត្រាច ខេត្តកំពត ដើម្បីជាការគាំទ្រ និងឧបត្ថម្ភដល់សកម្មភាពប្រណាំងទូកង របស់ប្រជាពលរដ្ឋក្នុងស្រុកកំពង់ត្រាច។',
        date: 'Monday June 22, 2019',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_9.jpg',
        class: 'contribution',
        url: 'water-festival'
      },
      {
        title: 'Annual Staff Assembly 2019',
        titleKh: 'សន្និបាតបុគ្គលិកប្រចាំឆ្នាំ ២០១៩',
        desc: 'The Company organized a 2-day Annual Staff Assembly from 14 -15 December 2019 at Than Suor Bok Kor Resort, Kampot province. The Assembly was held with the objectives of promoting team building, and holding the staff meeting...',
        descKh: 'ស្ថាប័ន បានរៀបចំកម្មវិធីសន្និបាតបុគ្គលិកប្រចាំឆ្នាំ ដែលមានរយៈពេល ២ ថ្ងៃ គឺចាប់ពីថ្ងៃទី១៤ ដល់ ទី១៥ ខែធ្នូ ឆ្នាំ ២០១៩ នៅរមណីយដ្ឋានឋានសួរបូកគោ ខេត្តកំពត។ សន្និបាតបុគ្គលិកនេះ ត្រូវបានរៀបចំឡើងក្នុងគោលបំណងលើកកម្ពស់ក្នុងការកសាងក្រុម បុគ្គលិក និងកិច្ចប្រជុំរបស់បុគ្គលិក។',
        date: 'Monday June 22, 2019',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_10.jpg',
        class: 'annual-staff',
        url: 'annual-staff'
      },
      {
        title: 'Grand Opening of NongHyup Finance',
        titleKh: 'ពិធីសម្ពោធឲ្យដំណើរការជាផ្លូវការរបស់ ណុងហឹប ហ្វាយនែន',
        desc: '11 September 2018 witnesses the Grand Opening Ceremony of NongHyup Finance (Cambodia) Plc at Hotel Sofitel Phnom Penh Phokeethra, presided over by Mr. KITH Sovannarith, Deputy Director General and Director of...',
        descKh: 'ពិធីសម្ពោធឲ្យដំណើរការជាផ្លូវការរបស់គ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុណុងហឹប ហ្វាយនែន (ខេមបូឌា) ម.ក បានប្រារព្ធធ្វើឡើងនៅសណ្ឋាគារ សូហ្វីតែល ភ្នំពេញ ភូគីត្រា នៅថ្ងៃអង្គារ ២កើត ខែភទ្របទ ឆ្នាំច សំរឹទ្ធិស័ក ព.ស.២៥៦២ ត្រូវនឹងថ្ងៃទី១១ ខែកញ្ញា ឆ្នាំ២០១៨ ក្រោមអធិបតីភាព លោក គិត សុវណ្ណារិទ្ធិ អគ្គនាយករងត្រួតពិនិត្យ និងជាប្រធាននាយកដ្ឋានត្រួតពិនិត្យឯកសារ របស់ធនាគារជាតិនៃកម្ពុជា និង លោក LEE Dae Houn ប្រធាននាយកប្រតិបត្តិ នៃធនាគារ NongHyup ព្រមទាំងការអញ្ជើញចូលរួមពីសំណាក់ និយតករ ដៃគូពាណិជ្ជកម្ម ភាគី ពាក់ព័ន្ធ និងថ្នាក់គ្រប់គ្រងនៃធនាគារ NongHyup និងគ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន ប្រមាណជាង១៤០រូប។',
        date: 'Wednesday May 8, 2018',
        img: this.baseApiUrl + '/uploads/images/what_new/what_new/what_new_11.jpg',
        class: 'grand-opening',
        url: 'grand-opening'
      },
    ];
  
  
    previousPage(): void {
      if (this.page > 1) {
        this.page--;
        this.router.navigate(['/what-new', this.page]);
      }
    }
  
    nextPage(): void {
      if (this.page < 2) { // Assuming 3 is the maximum page
        this.page++;
        this.router.navigate(['/what-new', this.page]);
      }
    }
  
    isPreviousDisabled(): boolean {
      return this.page == 1;
    }
  
    isNextDisabled(): boolean {
      return this.page == 2;
    }
  
    navigateToPage(pageId: string) {
      this.router.navigate(['/page', pageId]);
    }

}
